import { render, staticRenderFns } from "./step-case-category-details-panel.vue?vue&type=template&id=c340432e&scoped=true&"
import script from "./step-case-category-details-panel.vue?vue&type=script&lang=js&"
export * from "./step-case-category-details-panel.vue?vue&type=script&lang=js&"
import style0 from "./step-case-category-details-panel.vue?vue&type=style&index=0&id=c340432e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c340432e",
  null
  
)

export default component.exports